module.exports = __webpack_public_path__ + "static/media/puck1.de2a3c7b.png";